import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Dashboard from "../components/Dashboard";
import ImageModal from "../components/ImageModal";
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux";

import * as actions from "../actions";
class NigokiPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_image_url: "",
      active_filter_button: "1"
    };
    this.setActiveImage = this.setActiveImage.bind(this);
  }
  setActiveImage(image_url) {
    this.setState({ active_image_url: image_url });
  }
  componentWillMount() {
    this.props.fetchImages(this.state.active_filter_button);
  }
  render() {
    return (
      <div className="row">
      <MetaTags>
          <title>Tuck and Rose: Wedding Photostream</title>
      </MetaTags>

      <div className="paper-bg-container"></div>
        {this.state.active_image_url ? (
          <ImageModal
            active_image_url={this.state.active_image_url}
            setActiveImage={this.setActiveImage}
          />
        ) : null}
        <Header />

        <Dashboard
          setActiveImage={this.setActiveImage}
          images={this.props.images}
          active_filter_button={this.state.active_filter_button}
        />
        
        <Footer />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    images: state.images
  };
}
export default connect(mapStateToProps, actions)(NigokiPage);



// WEBPACK FOOTER //
// ./src/containers/NigokiPage.js